// extracted by mini-css-extract-plugin
module.exports = {"flameIcon":"_bdc3c97","flameIconBadge":"_7b0226e"};